<template>
  <section class="background-pattern-sand-100">
    <ContentContainer>
      <section class="py-[42px] lg:py-21 flex flex-col gap-14 relative">
        <!-- Topic header -->
        <slot name="topicHeader">
          <component :is="renderCustomElements(topicHeader)" />
        </slot>
        <!-- Topics -->
        <section class="flex flex-row flex-wrap gap-4 max-w-7xl relative">
          <ParagraphSingleTopicDefault
            v-for="topic in topics"
            :key="topic?.topicCopy?.sectionHeading || ''"
            :topic="topic"
            @selected-topic="handleSelectedTopic"
          />
        </section>

        <Transition>
          <ParagraphTopicsTopic
            v-if="selectedTopic"
            :selected-topic="selectedTopic"
            @close="handleCloseTopic"
          />
        </Transition>
      </section>
    </ContentContainer>
  </section>
</template>

<script setup lang="ts">
import type { AiTopic, SelectedTopic } from '~/types';

const { renderCustomElements } = useDrupalCe();

const { topics } = defineProps<{
  topics: AiTopic[];
}>();

const { topicHeader } = defineSlots<{
  topicHeader(): any;
}>();

const selectedTopic = ref<SelectedTopic | null>(null);
const handleCloseTopic = () => (selectedTopic.value = null);

const handleSelectedTopic = (payload: SelectedTopic) => {
  selectedTopic.value = payload;
};

// Provide handler so paragraph-single-topic can call it regardless of
// the Drupal CE wrapper (which breaks direct emit to this parent).
provide('onSelectedTopic', handleSelectedTopic);
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
